import type { Dispatcher } from "hooks";
import { ApiState } from "infrastructure/api";
import { Repository as BaseRepository, RepositoryActionType } from "../../Repository";
import type { DiffColumn, HistoryRepository, HistoryRepositoryState } from "./types";

export class Repository extends BaseRepository<HistoryRepositoryState> implements HistoryRepository {
    public constructor(
        public readonly state: HistoryRepositoryState,
        protected readonly dispatch: Dispatcher<RepositoryActionType>,
        public readonly fetchHandler: (searchQueryParams?: string) => Promise<HistoryRepositoryState['data']>,
    ) {
        super(state, dispatch);
    }

    public get data() {
        return this.state.data;
    }

    public get columns() {
        return Array.from(
            this.data
                .reduce((acc, record) => new Set<DiffColumn>([
                    ...Array.from(acc),
                    ...Object.keys(record) as DiffColumn[]
                ]), new Set<DiffColumn>())
        );
    }

    public override get isRepositoryEmpty() {
        return Boolean(
            [ApiState.Succeeded]
                .includes(this.state.apiState) &&
            !this.state.data.length
        );
    }
}
